<template>
    <v-dialog v-model="displayModal" width="550">
        <v-card>
            <v-card-text>{{ message | translation }}</v-card-text>
            <v-card-actions>
                <v-btn
                    @click="displayModal = !displayModal"
                    color="primary"
                    large
                    type="submit"
                >{{'Close' | translation}}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import {mapMutations} from 'vuex';
    import Login from '../Login/LoginForm';

    export default {
        name: 'RegistrationSuccessModal',
        props: {
            value: Boolean,
            message: {
                default: '',
                type: String,
            },
        },
        computed: {
            displayModal: {
                get() {
                    return this.value;
                },
                set(val) {
                    this.$emit('input', val);
                },
            },
        },
        methods: {
            ...mapMutations(Login.name, [
                'setShowLoginModal',
            ]),
        },
    };
</script>